var _excluded = ["visible", "show", "trigger", "showDelay", "hideDelay", "placement", "offset", "preventOverflow", "boundariesDetectionDebounce", "overflowBoundaries", "arrow", "arrowOffset", "getArrow", "getPopupContainer", "followTrigger", "hideToDestroy", "lazyInit", "zIndex", "popoverStyle", "className", "mode", "size", "content", "children", "disableAnimation", "scaleAnimation", "afterClose", "wrapperClassName", "popoverClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useMemo } from 'react';
import { useToggle, isClient } from '@okee-uikit/react-hooks';
import { usePrefixCls } from '@okee-uikit/react-config';
import { guid, combineClasses } from '@okee-uikit/react-utils';
import { RcPopper, RcTriggerGroup } from '../../hooks/popper';
import { ClickTrigger as PopoverClickTrigger } from '../popover/components/ClickTrigger';
import { HoverTrigger as PopoverHoverTrigger } from '../popover/components/HoverTrigger';
import { ManualTrigger as PopoverManualTrigger } from '../popover/components/ManualTrigger';
import { TooltipContent } from './TooltipContent';
export function Tooltip(props) {
  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      handleShow = _useToggle2[1],
      handleHide = _useToggle2[2];

  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var defaultGetPopupContainer = useCallback(function () {
    return isClient() ? document.body : null;
  }, []);

  var visible = props.visible,
      _props$show = props.show,
      propShow = _props$show === void 0 ? visible : _props$show,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'hover' : _props$trigger,
      showDelay = props.showDelay,
      _props$hideDelay = props.hideDelay,
      hideDelay = _props$hideDelay === void 0 ? 0 : _props$hideDelay,
      placement = props.placement,
      offset = props.offset,
      preventOverflow = props.preventOverflow,
      boundariesDetectionDebounce = props.boundariesDetectionDebounce,
      overflowBoundaries = props.overflowBoundaries,
      _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? true : _props$arrow,
      arrowOffset = props.arrowOffset,
      getArrow = props.getArrow,
      _props$getPopupContai = props.getPopupContainer,
      getPopupContainer = _props$getPopupContai === void 0 ? defaultGetPopupContainer : _props$getPopupContai,
      _props$followTrigger = props.followTrigger,
      followTrigger = _props$followTrigger === void 0 ? true : _props$followTrigger,
      hideToDestroy = props.hideToDestroy,
      lazyInit = props.lazyInit,
      zIndex = props.zIndex,
      popoverStyle = props.popoverStyle,
      className = props.className,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'dark' : _props$mode,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      content = props.content,
      children = props.children,
      disableAnimation = props.disableAnimation,
      scaleAnimation = props.scaleAnimation,
      afterClose = props.afterClose,
      wrapperClassName = props.wrapperClassName,
      popoverClassName = props.popoverClassName,
      extra = _objectWithoutProperties(props, _excluded);

  var cls = combineClasses(usePrefixCls('tooltip'), className);

  var triggerOpts = _objectSpread({
    className: cls
  }, extra);

  var popoverOpts = {
    placement: placement,
    offset: offset,
    preventOverflow: preventOverflow,
    boundariesDetectionDebounce: boundariesDetectionDebounce,
    overflowBoundaries: overflowBoundaries,
    arrow: arrow,
    arrowOffset: arrowOffset,
    getArrow: getArrow,
    getPopupContainer: getPopupContainer,
    hideToDestroy: hideToDestroy,
    lazyInit: lazyInit,
    zIndex: zIndex,
    disableAnimation: disableAnimation,
    scaleAnimation: scaleAnimation,
    afterClose: afterClose,
    wrapperClassName: wrapperClassName,
    onShow: handleShow,
    onHide: handleHide
  };
  var isTooltipShow = useMemo(function () {
    var realContent = typeof content === 'function' ? content() : content;
    return realContent !== false && realContent !== '' && realContent != null;
  }, [content]);
  var triggerWrapper = useMemo(function () {
    if (propShow !== undefined) {
      return React.createElement(PopoverManualTrigger, _objectSpread(_objectSpread({}, triggerOpts), {}, {
        show: propShow
      }), children);
    }

    if (trigger === 'click') {
      return React.createElement(PopoverClickTrigger, _objectSpread({}, triggerOpts), children);
    }

    if (trigger === 'hover') {
      return React.createElement(PopoverHoverTrigger, _objectSpread(_objectSpread({}, triggerOpts), {}, {
        showDelay: showDelay,
        hideDelay: hideDelay
      }), children);
    }

    return children;
  }, [propShow, trigger, children]);
  return React.createElement(RcPopper, null, React.createElement(RcTriggerGroup, {
    triggerGroupId: triggerId
  }, triggerWrapper), React.createElement(TooltipContent, _objectSpread(_objectSpread({}, popoverOpts), {}, {
    className: popoverClassName,
    show: propShow !== null && propShow !== void 0 ? propShow : show && isTooltipShow,
    mode: mode,
    size: size,
    content: content,
    style: popoverStyle,
    triggerIds: triggerIds,
    followTrigger: followTrigger
  })));
}